import React from 'react';
import { observer } from 'mobx-react';
import { WeaBrowser } from 'ecCom';

@observer
export default class BrowserNew extends React.Component<any, any>{

    onChange = (ids, names, datas) => {
        const {onChange,fieldtype,fieldid,isChild} = this.props;
        onChange(ids, names, datas,fieldtype,fieldid,isChild);
    }

    render() {
        return <WeaBrowser ecId={`${this && this.props && this.props.ecId || ''}_WeaBrowser@6arpcv`} 
            {...this.props}
            onChange={this.onChange}
        ></WeaBrowser>
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/commonComs/BrowserNew.tsx